// extracted by mini-css-extract-plugin
export default {"workspace":"Workspace-module_workspace_aa1dfb74"};